import { render, staticRenderFns } from "./present-dish-add.vue?vue&type=template&id=12444677&"
import script from "./present-dish-add.vue?vue&type=script&lang=js&"
export * from "./present-dish-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports